import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./potty-world/potty-world.module').then(m => m.PottyWorldPageModule)
	},
	{
		path: ':shortenedUrl',
		loadChildren: () => import('./shortened-url-redirect/shortened-url-redirect.module').then(m => m.ShortenedUrlRedirectModule)
	},
	{
		path: '**',
		loadChildren: () => import('./error-handling/404/page-not-found.module').then(m => m.PageNotFoundModule)
	}
];
@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
